<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/Approver'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-user-shield"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <!-- begin: Search input -->
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="aplSearch"
                    name="aplSearch"
                    v-model="aplSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากรัหส กลุ่มการอนุมัติเบิกยืม"
                  />
                </div>
              </div>
              <!-- end: Search input -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'aplAgentCode'"
                    :name="'aplAgentCode'"
                    :multiple="true"
                    :select2-options="aplAgentCodeOptions"
                    v-model="aplAgentCode"
                    ref="aplAgentCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="aplAgentCode"
                    :multiple="true"
                    :options="aplAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>พนักงาน :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'aplEmpId'"
                    :name="'aplEmpId'"
                    :multiple="true"
                    :select2-options="aplEmpIdOptions"
                    v-model="aplEmpId"
                    ref="aplEmpIdSelect2"
                  ></select2> -->

                  <treeselect
                    v-model="aplEmpId"
                    :multiple="true"
                    :load-options="LoadaplEmpIdOptions"
                    :async="true"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ผู้อนุมัติ :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'aplApprover'"
                    :name="'aplApprover'"
                    :select2-options="aplApproverOptions"
                    :multiple="true"
                    v-model="aplApprover"
                    ref="aplApproverSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="aplApprover"
                    :multiple="true"
                    :options="aplApproverOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'aplInActiveStatus'"
                    :name="'aplInActiveStatus'"
                    :select2-options="aplInActiveStatusOptions"
                    v-model="aplInActiveStatus"
                    ref="aplInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Approver/Add"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow(['MANAGE_MASTER', 'MANAGE_APPROVER'])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่ม
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="approverTable"
              >
                <thead>
                  <tr>
                    <th class="all">รหัสกลุ่มการอนุมัติเบิกยืม</th>
                    <th class="all">กลุ่มการอนุมัติเบิกยืม</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#approverTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Approver/" + this.data.requestHeaderId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#approverTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Approver/" + this.data.requestHeaderId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let ApproverActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editApprover" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteApprover" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    editApprover: function() {
      router.push({
        path: `/Master/Approver/Edit/${this.data.requestHeaderId}`,
      });
    },
    deleteApprover: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลผู้อนุมัติการเบิกยืมสินค้า",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลผู้อนุมัติการเบิกยืมสินค้า <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลผู้อนุมัติการเบิกยืมสินค้านี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder:
          "ต้องการลบข้อมูลผู้อนุมัติการเบิกยืมสินค้าออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/Approver/" + this.data.requestHeaderId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      aplSearch: null,
      // aplEmpId: null,
      // aplAgentCode: null,
      // aplApprover: null,
      aplEmpId: [],
      aplAgentCode: [],
      aplApprover: [],
      aplInActiveStatus: null,
      // Configurations
      aplEmpIdOptions: [],
      // aplEmpIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Employee/Select2Employee",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplAgentCodeOptions: [],
      // aplAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplApproverOptions: [],
      // aplApproverOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Users/Select2User",
      //     data: function(params) {
      //       var query = {
      //         userId: "",
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    LoadaplEmpIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.aplEmpIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Employee/Select2Employee", {
            params: { page: 1, all: true, search: searchQuery },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.aplEmpIdOptions = [];
              data.forEach((element) => {
                self.aplEmpIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.aplEmpIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadaplAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchAgentName", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.aplAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadaplApproverOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Users/Select2User", {
          page: 1,
          all: true,
          userId: "",
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.aplApproverOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    formReset: function(e) {
      let self = this;
      self.aplSearch = null;
      this.aplEmpId = [];
      this.aplAgentCode = [];
      this.aplApprover = [];
      // $("#aplAgentCode")
      //   .val("")
      //   .trigger("change");

      // $("#aplEmpId")
      //   .val("")
      //   .trigger("change");

      // $("#aplApprover")
      //   .val("")
      //   .trigger("change");

      //default Active Data
      this.aplInActiveStatus = false;
      $("#aplInActiveStatus")
        .val(this.aplInActiveStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#approverTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#approverTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadaplAgentCodeOptions();
    self.LoadaplApproverOptions();
    //default Active Data
    self.aplInActiveStatus = false;
    $("#aplInActiveStatus")
      .val(self.aplInActiveStatus + "")
      .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#approverTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Approver/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                AgentCode: self.aplAgentCode,
                EmpId: self.aplEmpId,
                Approver: self.aplApprover,
                SearchKeyword: self.aplSearch,
                InActiveStatus: self.aplInActiveStatus,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "asc"]],
        columns: [
          {
            data: "requestHeaderId",
            width: "20%",
            className: "text-center",
          },
          { data: "approveGroup", className: "text-center" },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "requestHeaderId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_APPROVER",
            ]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_APPROVER",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_APPROVER",
            ]);
            new ApproverActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Approver/ApproverList.vue